import React from 'react'
import { Link } from 'react-router-dom'
import "./Footer.css"

let contrastToggle = false;

function toggleContrast(){
    contrastToggle = !contrastToggle;
    if(contrastToggle) {
        document.body.classList += " dark-theme"

    }
    else {
        document.body.classList.remove("dark-theme") 
    }
}

function Footer() {
  return (
    <footer className='home__'>
        <div className="home__footer">
        <div className="home__footerLeft">
          <Link to="/about">About</Link>
          <Link to="/store">Advertising</Link>
          <Link to="/store">Business</Link>
        </div>
        <div className="home__footerRight">
          <Link to="/gmail">Privacy</Link>
          <Link to="/images">Terms</Link>
          <button className="btn" onClick={toggleContrast}>dark mode</button>
        </div>
      </div>
    </footer>
  )
}

export default Footer